import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { SuccessMsgUpdate } from "globalConstants";
import { getErrorMessage } from "helpers";
import { chargebacksService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseUnClaimChargebacksMutationProps = {
	id: number;
	onSuccessHandler?: Function;
};

const useUnClaimChargebacksMutation = ({ onSuccessHandler }) => {
	const dispatch = useDispatch();

	return useMutation(
		({ id }: UseUnClaimChargebacksMutationProps) => {
			dispatch(uiActions.showSpinnerOverlay());

			return chargebacksService.unClaimMerchant({
				id,
			});
		},
		{
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
			onSuccess() {
				dispatch(
					uiActions.showSuccessNotification({
						title: `Assignee ${SuccessMsgUpdate}`,
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUnClaimChargebacksMutation;
